import { useEffect } from "react";

export const useScrollTop = () => {
    useEffect(() => {
        document.documentElement.scrollTop = 0;
    }, []);
};
